import { render, staticRenderFns } from "./AddFromPaper.vue?vue&type=template&id=d1bc5a4c&scoped=true"
import script from "./AddFromPaper.vue?vue&type=script&lang=js"
export * from "./AddFromPaper.vue?vue&type=script&lang=js"
import style0 from "./AddFromPaper.vue?vue&type=style&index=0&id=d1bc5a4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1bc5a4c",
  null
  
)

export default component.exports